export default "__VITE_ASSET__e18abfe5__"